import { render, staticRenderFns } from "./platfromadduser.vue?vue&type=template&id=0ed70831&scoped=true&"
import script from "./platfromadduser.vue?vue&type=script&lang=js&"
export * from "./platfromadduser.vue?vue&type=script&lang=js&"
import style0 from "./platfromadduser.vue?vue&type=style&index=0&id=0ed70831&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed70831",
  null
  
)

export default component.exports